export default __webpack_public_path__ + "static/media/logo.daa03bb7.svg";